import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {ViewAccountSummaryLink} from "../../component"

export const TooltipFooterStyled = styled("div")`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
`

export const DividerStyled = styled("hr")`
    margin: 0;
    border: none;
    border-top: 1px solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
`

export const ViewAccountSummaryLinkStyled = styled(ViewAccountSummaryLink)`
    padding: 0.625rem 0.75rem;
    margin-right: 1rem;
    && a {
        font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        letter-spacing: ${({theme}) => theme.uxfabric.global.body3.letterSpacing};
        text-transform: ${({theme}) => theme.uxfabric.global.body3.textTransform};
    }
`

export const TooltipHeaderStyled = styled("div")`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
`

export const SignoutButtonStyled = styled("div")`
    height: 2.25rem;
    font-family: ${({theme}) => `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
    && a {
        padding: 0.3125rem;
    }
`
export const ToolTipUsernameStyled = styled("div")`
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.75rem;
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.global.body1.fontSize};
    line-height: ${({theme}) => theme.typography.body1.lineHeight};
    letter-spacing: ${({theme}) => theme.typography.body1.letterSpacing};
    text-transform: ${({theme}) => theme.typography.body1.textTransform};
`

export const ToolTipContentStyled = styled("div")`
    font-size: ${({theme}) => theme.typography.body1.fontSize};
    letter-spacing: ${({theme}) => theme.typography.body1.letterSpacing};
    text-transform: ${({theme}) => theme.typography.body1.textTransform};
    width: 16rem;
    border: 1px solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    text-transform: capitalize;
    text-align: center;
    overflow: hidden;

    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape) {
        position: absolute;
        top: -3.75rem;
    }
`
